// import type from 'postcss-pxtorem/lib/type'
import requests from '../request'

// 'Contont-type': 'application/json'
// 'Contont-type': 'application/x-www-form-urlencoded'

// 网格 事件 获取tree根节点列表
export const gridTreeAPI = (params) => {
  return requests({
    url: '/api/map/tree',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 网格 事件 树节点添加
export const saveMapNodeAPI = (params) => {
  return requests({
    url: '/api//map/saveMapNode',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 网格 事件 树节点删除
export const deleteMapNodeAPI = (params) => {
  return requests({
    url: '/api/map/deleteMapNode',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 网格 事件 树节点修改
export const updateMapNodeAPI = (data) => {
  return requests({
    url: '/api/map/updateMapNode',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
